import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import Icon from '@components/Icon/Icon';

const messages = defineMessages({
  splitAll: {
    id: 'autoCuration.pdfSplitEditor.splitAll',
    defaultMessage: 'Split All',
  },
  mergeAll: {
    id: 'autoCuration.pdfSplitEditor.mergeAll',
    defaultMessage: 'Merge All',
  },
  saving: {
    id: 'autoCuration.pdfSplitEditor.saving',
    defaultMessage: 'Saving...',
  },
  save: {
    id: 'autoCuration.pdfSplitEditor.save',
    defaultMessage: 'Save',
  },
  start: {
    id: 'autoCuration.pdfSplitEditor.start',
    defaultMessage: 'Start Auto Curation',
  },
});

interface EditorActionsProps {
  onSplitAll: () => void;
  onMergeAll: () => void;
  onSaveSplits: () => void;
  onStartAutoCuration: () => void;
  isSaving: boolean;
  isProcessing: boolean;
}

export const EditorActions = ({
  isProcessing,
  isSaving,
  onMergeAll,
  onSaveSplits,
  onSplitAll,
  onStartAutoCuration,
}: EditorActionsProps) => {
  const { formatMessage } = useIntl();

  return (
    <Stack spacing={1}>
      <Stack direction="row" spacing={1}>
        <Button
          variant="contained"
          color="error"
          size="small"
          onClick={onSplitAll}
          fullWidth
        >
          {formatMessage(messages.splitAll)}
        </Button>
        <Button
          variant="contained"
          color="success"
          size="small"
          onClick={onMergeAll}
          fullWidth
        >
          {formatMessage(messages.mergeAll)}
        </Button>
      </Stack>
      <Stack direction="row" spacing={1}>
        {/* Save Button */}
        <Button
          variant="contained"
          color="primary"
          onClick={onSaveSplits}
          disabled={isSaving || isProcessing}
          fullWidth
        >
          {formatMessage(isSaving ? messages.saving : messages.save)}
        </Button>

        {/* Auto Curation Button */}
        <Button
          startIcon={<Icon name="brain" type="fas" />}
          variant="contained"
          color="primary"
          onClick={onStartAutoCuration}
          disabled={isProcessing || isSaving}
          sx={{
            opacity: isProcessing ? 0.5 : 1,
          }}
          fullWidth
        >
          {formatMessage(messages.start)}
        </Button>
      </Stack>
    </Stack>
  );
};
